/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ethereum_chain_about = () => `Ethereum emerges as a decentralized, open-source blockchain platform empowering developers to craft and deploy smart contracts alongside dApps. Pioneering the smart contract concept, Ethereum enables self-executing agreements with terms directly encoded into its blockchain, eliminating the need for intermediaries. Additionally, Ethereum serves as a hub for the creation and exchange of NFTs (Non-Fungible Tokens) and various digital assets. Its intrinsic cryptocurrency, Ether (ETH), facilitates network transactions and incentivizes miners to uphold network security. Ethereum's evolution to Ethereum 2.0 introduces a proof-of-stake (PoS) mechanism, aiming to enhance scalability and energy efficiency.`
